var map = {
	"./en-CA.yaml": [
		74,
		32
	],
	"./en-US.yaml": [
		75,
		33
	],
	"./es-US.yaml": [
		76,
		34
	],
	"./fr-CA.yaml": [
		77,
		35
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 68;
module.exports = webpackAsyncContext;